import { type MUIDataTableState } from 'mui-datatables';

export const paginateAndSort = <T>(data: T[], tableState: MUIDataTableState): [T[], number] => {
    let fullData = data;
    const sortField = tableState.sortOrder.name;
    const sortDir = tableState.sortOrder.direction;

    if (sortField) {
        fullData = fullData.sort((a, b) => {
            if (a[sortField] < b[sortField]) {
                return 1 * (sortDir === 'asc' ? -1 : 1);
            } if (a[sortField] > b[sortField]) {
                return -1 * (sortDir === 'asc' ? -1 : 1);
            }
            return 0;
        });
    }

    return [
        fullData.slice(tableState.page * tableState.rowsPerPage, (tableState.page + 1) * tableState.rowsPerPage),
        fullData.length
    ];
};
